<div [ngClass]="['valuePreferencePanel p-col-12']">
  <div class="valuePreference-fields-container">
    <iu-input-text-ui
      data-cy="valuePreferencePanel-attribute"
      [cssClass]="'p-col-12 p-md-12 p-lg-12'"
      [fieldValue]="attributeDisplayValue"
      [isReadOnly]="true"
      [isStandalone]="true"
      label="{{ 'valuePreference.attributeLabel' | translate }}" />
    <iu-input-text-ui
      data-cy="valuePreferencePanel-value"
      [cssClass]="'p-col-12 p-md-12 p-lg-12'"
      [fieldValue]="displayValue"
      [isReadOnly]="true"
      [isStandalone]="true"
      label="{{ 'valuePreference.value' | translate }}" />
    <p class="help" data-cy="valuePreferencePanel-desc">{{ description }}</p>
  </div>
  <div class="valuePreference-checkbox-container">
    <iu-input-switch-ui
      cssGrid="p-col-6 p-md-6 p-lg-6"
      data-cy="valuePreferencePanel-switch-client"
      style="text-align: left"
      [fieldValue]="adClient"
      [isReadOnly]="true"
      [isStandalone]="true"
      label="{{ 'valuePreference.adClient' | translate }}" />
    <iu-input-switch-ui
      cssGrid="p-col-6 p-md-6 p-lg-6"
      data-cy="valuePreferencePanel-switch-org"
      style="text-align: left"
      [fieldValue]="adOrg"
      [isReadOnly]="adOrgReadOnly"
      [isStandalone]="true"
      label="{{ 'valuePreference.adOrg' | translate }}"
      (fieldValueModified)="updateToggleValue('adOrg', $event)" />
    <iu-input-switch-ui
      cssGrid="p-col-6 p-md-6 p-lg-6"
      data-cy="valuePreferencePanel-switch-user"
      style="text-align: left"
      [fieldValue]="adUser"
      [isReadOnly]="adUserReadOnly"
      [isStandalone]="true"
      label="{{ 'valuePreference.adUser' | translate }}"
      (fieldValueModified)="updateToggleValue('adUser', $event)" />
    <iu-input-switch-ui
      cssGrid="p-col-6 p-md-6 p-lg-6"
      data-cy="valuePreferencePanel-switch-window"
      style="text-align: left"
      [fieldValue]="adWindow"
      [isStandalone]="true"
      label="{{ 'valuePreference.adWindow' | translate }}"
      (fieldValueModified)="updateToggleValue('adWindow', $event)" />
  </div>
  <div class="valuePreference-btn-container">
    @if (isDeletable) {
      <button class="p-button p-button-secondary" data-cy="valuePreferencePanel-btn-delete" (click)="delete($event)">
        {{ 'valuePreference.delete' | translate }}
      </button>
    }
    <button class="p-button p-button-secondary" data-cy="valuePreferencePanel-btn-cancel" (click)="cancel($event)">
      {{ 'valuePreference.cancel' | translate }}
    </button>
    <button class="p-button p-button-primary" data-cy="valuePreferencePanel-btn-save" (click)="save($event)">
      {{ 'valuePreference.save' | translate }}
    </button>
  </div>
</div>
